import React from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { TabsHistory } from '../../../app/components/TabsHistory';

import { ExamsInActiveView } from './ExamsInActiveView';

export const ExamsOnlineView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();

  const handleClick = async (id: string) => {
    void nav.examTests(id);
  };

  return (
    <Card>
      <TabsHistory
        activeKey={'waitingJudgments'}
        id="exams-online"
        className="mb-3"
        mountOnEnter={true}
        unmountOnExit={true}
      >
        <Tab
          eventKey="waitingJudgments"
          title="Oczekujące na orzeczenia"
          className="m-3"
        >
          <ExamsInActiveView
            getData={spd.exams.getOnlineWithoutJudgmentByPortion}
            getCount={spd.exams.getOnlineWithoutJudgmentCount}
            onRowClick={handleClick}
            initialOrderColumn="exams.endDate"
            initialOrderDirection="ASC"
            withFilterInColumns={true}
          />
        </Tab>
        <Tab eventKey="all" title="Wszystkie" className="m-3">
          <ExamsInActiveView
            getData={spd.exams.getOnlineAllByPortion}
            getCount={spd.exams.getOnlineAllCount}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
